<template>
  <div>
    <div class="box-header">Notes for customer (visible in invoice)</div>
    <div class="content">
      <template v-if="!edit">
        <div v-if="notes" class="customer-note">{{ notes }}</div>
        <div v-else class="empty-state">
          <i class="mdi mdi-message-text-outline"></i>
          <p>No notes for the customer</p>
        </div>
        <div class="form-actions">
          <button type="button" class="form-btn" @click="startEditing()">
            <i
              class="mdi"
              :class="notes ? 'mdi-pencil-outline' : 'mdi-plus'"
            ></i>
            {{ notes ? "Edit note" : "Add note" }}
          </button>
        </div>
      </template>
      <template v-else>
        <input
          ref="noteInput"
          class="regular full bordered"
          type="text"
          name="name"
          placeholder="This text is printed on the invoice"
          v-model="newNote"
          @keyup.enter="saveChanges()"
        />
        <div class="form-actions">
          <button
            v-if="!loading"
            type="button"
            class="form-btn"
            @click="revertChanges()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="form-btn is-primary"
            :disabled="loading"
            @click="saveChanges()"
          >
            <i
              class="mdi"
              :class="loading ? 'mdi-loading mdi-spin' : 'mdi-check'"
            ></i>
            {{ loading ? "Saving..." : "Save" }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { updateOrder } from "@/api/store/OrdersService.js";

export default {
  name: "CustomerNotes",
  props: {
    notes: {
      validator: prop => typeof prop === "string" || prop === null,
      required: true
    },
    orderNumber: {
      type: String,
      required: true
    },
    editing: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      edit: false,
      newNote: "",
      loading: false
    };
  },
  methods: {
    startEditing() {
      this.newNote = this.notes;
      this.edit = true;
      this.$nextTick(() => {
        if (this.$refs.noteInput) this.$refs.noteInput.focus();
      });
    },
    revertChanges() {
      this.edit = false;
      this.$emit("finishedEditing", false);
    },
    saveChanges() {
      if (!this.loading) {
        this.loading = true;
        updateOrder(this.orderNumber, "notes_customer", { notes: this.newNote })
          .then(() => {
            this.$emit("finishedEditing", true);
          })
          .catch(() => {
            console.log("error updating order");
            this.$toast.open({
              message: "Error saving customer note",
              type: "error",
              position: "top-right"
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.customer-note {
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  font-size: 16px;
  color: #111827;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 1.5rem 1rem;
  color: #6b7280;

  i {
    font-size: 2.25rem;
    color: #d1d5db;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}

.form-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  font-size: 16px;
  font-weight: 500;
  color: #374151;

  i {
    font-size: 18px;
  }

  &:hover:not(:disabled) {
    background: #f9fafb;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &.is-primary {
    border-color: #126e6a;
    background: #126e6a;
    color: white;

    &:hover:not(:disabled) {
      filter: brightness(1.1);
    }
  }
}
</style>
